import { useMemo } from "react";
import { ViewBooking } from "collins-js-sdk";
import { VenueConfig } from "../../../../../types/venues";
import { VenueGroupConfig } from "../../../../../types/VenueGroup";
import {
  filterActiveBookings,
  filterAwaitingArrivalBookings,
  filterCheckedInBookings,
  filterBookingsByStage
} from "../../../../../utils/booking";

export const useBookingFilter = (
  sortedBookings: ViewBooking[],
  activeFilter: string, // Dynamic stage IDs - can be "all", "awaiting-arrival", "checked-in", or any stage ID
  searchQuery: string,
  searchResults: ViewBooking[],
  venueConfig: VenueConfig | null,
  venueGroupConfig: VenueGroupConfig | null
): ViewBooking[] => {
  return useMemo(() => {
    const bookings = searchQuery ? searchResults : sortedBookings;

    // Filter out bookings that should never appear on runsheet
    const nonRejectedBookings = filterActiveBookings(bookings);

    switch (activeFilter) {
      case "awaiting-arrival":
        return filterAwaitingArrivalBookings(nonRejectedBookings);
      case "checked-in":
        return filterCheckedInBookings(nonRejectedBookings);
      default: {
        // Dynamic stage filtering - filter by specific stage ID
        if (activeFilter !== "all") {
          return filterBookingsByStage(nonRejectedBookings, activeFilter);
        }
        return nonRejectedBookings;
      }
    }
  }, [
    sortedBookings,
    activeFilter,
    searchQuery,
    searchResults,
    venueConfig,
    venueGroupConfig
  ]);
};
